export const strings = {
    global: {
        businessName: "לצאת לחופשי - בקצב שלך",
    },
    contact: {
        phone: "050-5456644",
        email: "haggaimagen87@gmail.com",
        address1: "פתח תקווה",
        address2: "ישראל",
    },
    home: {
        hero: {
        title: "המסע שלך לחיים בריאים מתחיל כאן\n",
        subtitle: "להחזיר את הבריאות והכושר לחיים בתהליך הדרגתי ומותאם אישית עבורך",
        primaryButton: "התחל את המסע שלך",
        secondaryButton: "למד עוד"
        },
        cards: [
        {
            title: "למה שום דבר לא עובד?",
            content: "אם אתה לא מצליח להחזיר את החיים שלך למסלול, לרדת במשקל ולחזור לכושר, זה לא בגלל שתוכנית האימון שלך לא מספיק טובה. בטח גם ניסית דיאטות כאלה ואחרות, אולי תפריט תזונה מותאם אישית. יכול להיות שכבר לקחת מאמן שהסביר לך ונתן לך תוכנית אימונים. שילמת למאמנים ולתזונאים הכי טובים שיש בשוק, ובכל זאת - בסוף חזרת לנקודת ההתחלה.\n\nולכן - לא משנה כמה מוכשר המאמן שלקחת, לא משנה כמה מנוסה התזונאי שאמר לך מה לאכול, אם לא הצלחת להגיע או שכמעט הגעת אבל אתה לא מצליח לשמר את התוצאות, <strong>יכול להיות שהשיטות שיש לעולם להציע לך פשוט לא מתאימות לך<strong>."
        },
        {
            title: "זה לא \"זבנג וגמרנו\"",
            content: "לפעמים שינוי קיצוני יכול להיות גדול עלינו. במקום לקדם אותנו, הוא מפעיל עלינו לחץ, פוגע לנו במוטיבציה וגורם לנו לוותר. להגיע למכון הכושר בפעם הראשונה בלי להכיר אף אחד, כשכולם שם נראים חזקים ומתאמנים כבר שנים - כנראה מרגיש יותר מדי מחוץ לאיזור הנוחות שלך. התחושה שכולם מסתכלים עליך ושופטים אותך, המחשבה על זה שאתה לא ממש יודע מה אתה עושה. אתה לא מרגיש מספיק בכושר כדי ללכת למכון הכושר, אתה אומר לעצמך שאתה רזה מדי/שמן מדי/חלש מדי, ובטח שלא מספיק בכושר כדי להתחיל לרוץ או ללכת לחוג כלשהו.\n\nאתה מרגיש לא בנוח עם המשקל והמראה שלך, אבל גם לשנות את התזונה מקצה לקצה ביום אחד - להתחיל דיאטה - רק מרגיש כמו להיכנס ללופ אינסופי של סבל, ובסופו של דבר תמיד אתה חוזר לנקודת ההתחלה או גרוע מזה."        
        }],
        highlight: {
            sentences: [
                "אם אתה מאוד רוצה לעשות שינוי ולא יודע איך להתחיל",
                "אם כל מה שיש לעולם הכושר להציע לך מרגיש גדול עליך", 
                "אם כל מה שניסית עד היום לא עבד",
            ],
            closing: "הגעת למקום הנכון."
        },
        contact: {
            title: "מוכן להתחיל את השינוי שלך?",
            subtitle: "צור איתנו קשר היום וקח את הצעד הראשון לקראת חיים בריאים ומאושרים יותר.",
            nameLabel: "שם מלא",
            namePlaceholder: "הזן את השם המלא שלך",
            emailLabel: "כתובת אימייל",
            emailPlaceholder: "הזן את כתובת האימייל שלך",
            submitButton: "התחל היום",
            thankYouMessage: "תודה",
            followUpMessage: "ניצור איתך קשר בכתובת",
            soon: "בקרוב",
            fillAllFields: "אנא מלא את כל השדות."
        }
    }
}